<template lang="pug">
  #sa
    router-view
</template>

<script>
import store from '../../store';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'SaComponent',
  beforeRouteEnter(to, from, next) {
    store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        store.commit('toggleLoading', false);
        next();
      });
  }
};
</script>
